



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class TimeoutModal extends Vue {
    @Prop() private isTop! : boolean;
    @Prop() private isSns! : boolean;

    title = "自動ログアウト";
    message1 = "最終ご利用時間から15分経過したためアカウントからログアウトしました。";
    message2 = "ラベル屋さんクラウド、各種クラウド、SNS連携をご利用になるには再度ログインしてください。";

    onOk(){
        if(this.isTop || this.$router.currentRoute.path == "/signIn"){
            this.$emit("close");
        }
        else if(this.isSns){
            this.$router.push("/SelectTemplate");
        }
        else{
            this.$router.push("/signIn");
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
